/* eslint-disable import/prefer-default-export */
export const isImage = (mime) => (mime.split('/', 1)[0] === 'image' ? 'imageTransfer' : 'fileTransfer')

export const participantToMessageType = {
  AGENT: 'agent',
  BOT: 'system',
  CUSTOMER: 'user',
}
